import { useSyncExternalStore } from 'react';
import { ProgressStore } from '../store/ProgressStore.js';

/** Jediná inštancia pre celú aplikáciu. */
export const store = new ProgressStore();

const subscribe = (onChange: () => void) => store.subscribe(onChange);
const getRevision = () => store.revision;
const getServerRevision = () => 0;

/**
 * Prihlási komponent na zmeny v úložišti pokroku.
 * Vráti číslo revízie — komponent potom číta dáta priamo zo `store`,
 * ale prekreslí sa vždy, keď sa zmenia.
 */
export function useStoreRevision(): number {
  return useSyncExternalStore(subscribe, getRevision, getServerRevision);
}
